module.exports = __webpack_public_path__ + "static/2-1d68d3055c9d6449cef772bf25667915.png";